/*eslint new-cap:0 */
import ko from 'knockout';
import _ from 'underscore';
import Backbone from 'backbone';
import ViewModel from '@bingads-webui-campaign-legacy/advanced-settings/viewmodel/automated-cta';
import template from '@bingads-webui-campaign-legacy/advanced-settings/template/automated-cta.pug';
import pageContext from '@bingads-webui-static-legacy/page-context';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');

export default class View extends Backbone.View {
  initialize({
    callToActionSetting,
    scenario,
    activityLogger}) {
    this.viewModel = new ViewModel();
    this.callToActionSetting = callToActionSetting;
    this.activityLogger = activityLogger;
    this.scenario = scenario;
  }


  showAutoMatedCTA() {
    return Boolean(_.result(pageContext.Permissions, 'IsMMAAutomatedCTAOptInEnabled', false)) && this.scenario === 'campaign-settings';
  }

  initAutomatedCTA() {
    if (this.showAutoMatedCTA()) {
      this.viewModel.showAutoMatedCTA(true);
      if (this.callToActionSetting && this.callToActionSetting.AutomatedCallToActionOptOut) {
        this.viewModel.autoMatedCTAEnabled(false);
      }
      this.viewModel.autoMatedCTAEnabled.subscribe((checked) => {
        if (this.activityLogger) {
          this.activityLogger.signal(`autoMatedCTAEnabled:${checked}`, 'autoMatedCTA');
        }
      });
    }
  }

  getValues() {
    const isChanged = (this.callToActionSetting && this.callToActionSetting.AutomatedCallToActionOptOut !== !this.viewModel.autoMatedCTAEnabled()) || (!this.callToActionSetting && !this.viewModel.autoMatedCTAEnabled());

    return isChanged ? {
      AutomatedCallToActionOptOut: !this.viewModel.autoMatedCTAEnabled(),
    } : {};
  }

  render() {
    this.initAutomatedCTA();
    this.$el.html(template({i18n}));

    ko.applyBindings(this.viewModel, this.el);

    return this;
  }

}
